import React, { Component } from 'react'
import img404 from '../../assets/images/404.png'
import CurrentPage from './css.js'
export default class NotDefined extends Component {
	render() {
		return (
			<CurrentPage className="not-defined">
				{/* <div className="not-defined"> */}
					<img src={img404} alt="" />

			{/*		<div className="btn" onClick={this.back}>
						返回首页
				</div>*/}
				{/* </div> */}
			</CurrentPage>

		)

	}
	back = () => {
		this.props.history.push('/')
	}
}
